<img *ngIf="!!imageSrc" [src]="imageSrc" [ngStyle]="{'width': width, 'height': height}">